import { injectStyles, getVariant, Box, BoxProps } from '@apia/theme';
import { forwardRef } from 'react';
import { RequiredMark } from './RequiredMark';

export type TFieldLabel = {
  avoidSemicolon?: boolean;
  /**
   * Permite mostrar un mensaje de error debajo del campo
   */
  error?: string;
  hideRequiredMark?: boolean;
  label: string;
  /**
   * La propiedad required se utiliza para mostrar el * de requerido.
   *
   * @see requiredMarkPosition
   * @see hideRequiredMark
   */
  required?: boolean;
  requiredMarkPosition?: 'before' | 'after';
} & BoxProps;

injectStyles('layout.common.components.fieldLabel', {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,

  '.fieldLabel__label': {
    fontWeight: 'bold',
  },
});

export const FieldLabel = forwardRef<HTMLDivElement, TFieldLabel>(
  (
    {
      as,
      avoidSemicolon,
      children,
      error,
      hideRequiredMark,
      label,
      required,
      requiredMarkPosition = 'after',
      ...props
    },
    ref,
  ) => {
    return (
      <Box
        as={as ?? 'label'}
        {...props}
        className={`fieldLabel ${props.className ?? ''}`}
        {...getVariant('layout.common.components.fieldLabel')}
        aria-label={props['aria-label'] ?? label}
        ref={ref}
      >
        <Box className="fieldLabel__label">
          {requiredMarkPosition === 'before' && (
            <RequiredMark
              isRequired={required}
              isReadonly={hideRequiredMark}
              isFormReadonly={hideRequiredMark}
            />
          )}
          {label}
          {requiredMarkPosition === 'after' && (
            <RequiredMark
              isRequired={required}
              isReadonly={hideRequiredMark}
              isFormReadonly={hideRequiredMark}
            />
          )}
          {!avoidSemicolon && ':'}
        </Box>
        <Box>{children}</Box>
        {error && <Box className="fieldLabel__error">{error}</Box>}
      </Box>
    );
  },
);

FieldLabel.displayName = 'FieldLabel';
